import { render } from "./ReleaseNotesUpdate.vue?vue&type=template&id=44771c62&scoped=true"
import script from "./ReleaseNotesUpdate.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesUpdate.vue?vue&type=script&lang=js"

import "./ReleaseNotesUpdate.vue?vue&type=style&index=0&id=44771c62&scoped=true&lang=css"

import exportComponent from "c:\\Qedtek Project\\Takayama-New\\takayama_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44771c62"]])

export default __exports__